
const digest = '1eccfa8284f1fc0013fea8800e454c1a8a2e3a1c33f448480b1e1f8203e7f99a';
const classes = {"item":"_item_tpxs9_1","name":"_name_tpxs9_7","address":"_address_tpxs9_10","mainWorkplace":"_mainWorkplace_tpxs9_15","subtitle":"_subtitle_tpxs9_22","title":"_title_tpxs9_33"};
const css = `._item_tpxs9_1 {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 0 20px;
}
._item_tpxs9_1 ._name_tpxs9_7 {
  font-weight: 500;
}
._item_tpxs9_1 ._address_tpxs9_10 {
  font-size: 14px;
  color: #787878;
}

._mainWorkplace_tpxs9_15 {
  display: flex;
  flex-direction: column;
  background-color: #e7f5fb;
  padding: 20px;
  gap: 3px;
}
._mainWorkplace_tpxs9_15 ._subtitle_tpxs9_22 {
  font-size: 14px;
}
._mainWorkplace_tpxs9_15 ._name_tpxs9_7 {
  font-weight: 500;
}
._mainWorkplace_tpxs9_15 ._address_tpxs9_10 {
  font-weight: 500;
  font-size: 14px;
}

._title_tpxs9_33 {
  padding: 0 20px;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  